













import getImageSource from "@/helpers/getImageSource";
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class ImgLink extends Vue {
  @Prop({required: true}) path!: string
  @Prop({required: true}) imgUrl!: string
  @Prop({required: true}) imageSize!: string
  @Prop({required: true}) openInNewTab!: number
  @Prop({required: false}) className?: string
  @Prop({required: false}) title?: string

  get isOpenInNewTab(){
    return this.openInNewTab? '_blank': '_self'
  }

  public getImageSource(size: string, path: string){
    return getImageSource(size, path)
  }

  get theClassName(){
    return this.className? this.className:''
  }

  get theTitle(){
    return this.title? this.title: null
  }

  get isExternalLink(){
    return this.path.startsWith('https')
  }
}
